export default __webpack_public_path__ + "media/zurb/img/services/services/web-application-img-db1f46d80810b10fe1d8ba59a84c31e8.png";